import { render, staticRenderFns } from "./SaleEdit.vue?vue&type=template&id=0bcbbeca&scoped=true&"
import script from "./SaleEdit.vue?vue&type=script&lang=js&"
export * from "./SaleEdit.vue?vue&type=script&lang=js&"
import style0 from "./SaleEdit.vue?vue&type=style&index=0&id=0bcbbeca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbbeca",
  null
  
)

export default component.exports